// A page whose phase is not built yet: honest empty state naming the phase (frozen mockup SCR-FND-03).
// Truck pages show the context strip (GEN-14); its truck and round lists are filled in phase P5.
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { ContextStrip, EmptyState, Field, Input, Select } from '../design/kit';
import { businessToday } from '../lib/format';
import type { PageDef } from './pages';

export function PagePlaceholder({ page }: { page: PageDef }) {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const workingDate = params.get('date') ?? businessToday();
  return (
    <>
      {page.truck && (
        <ContextStrip
          truck={
            <Field label={t('truck')}>
              {({ id }) => (
                <Select id={id} disabled defaultValue="">
                  <option value="">—</option>
                </Select>
              )}
            </Field>
          }
          round={
            <Field label={t('round')}>
              {({ id }) => (
                <Select id={id} disabled defaultValue="">
                  <option value="">—</option>
                </Select>
              )}
            </Field>
          }
          workingDate={
            <Field label={t('workdate')}>
              {({ id }) => (
                <Input
                  id={id}
                  type="date"
                  dir="ltr"
                  value={workingDate}
                  max={businessToday()}
                  onChange={(e) => {
                    const next = new URLSearchParams(params);
                    next.set('date', e.target.value);
                    setParams(next, { replace: true });
                  }}
                />
              )}
            </Field>
          }
        />
      )}
      <EmptyState icon={page.icon} title={t('soon.title')} text={t('soon.text', { p: page.phase })} />
    </>
  );
}
